class SiteNavigation {
    constructor() {
    }

    init(helpers) {
        let menuNewsletterSubscribe = document.querySelector('.menu .connect-with-us .subscribe-to-our-newsletter-button'),
        menuNewsletterSubscribeLink = menuNewsletterSubscribe.querySelector('.link');

        menuNewsletterSubscribe.hidden = false;
        menuNewsletterSubscribe.classList.remove('js-hidden');

        menuNewsletterSubscribeLink.addEventListener('click', e => {
            e.preventDefault();

            let link = e.currentTarget,
                newsletterSignUp = document.querySelector(link.getAttribute('href')),
                menuDialog = link.closest('dialog.menu'),
                menuCloseButton = menu.querySelector('.close-button');

            menuDialog.close();

            wp.a11y.speak(i18n['menu']['automatically_closed']);

            window.location.hash = link.getAttribute('href').substring(1);

            newsletterSignUp.setAttribute('tabindex', '-1');
            newsletterSignUp.focus();
            newsletterSignUp.removeAttribute('tabindex');
        });

        var lastScrollPosition = window.scrollY;
        var navigation = document.querySelector('#header');
        window.onscroll = function() {
            if (window.innerWidth < 1200) {
                return;
            }
            if (Math.abs(window.scrollY - lastScrollPosition) >= 100) { // prevent the jitter from resizing navs
                if (window.scrollY > lastScrollPosition) {
                    navigation.classList.add("collapsed");
                } else if (window.scrollY < lastScrollPosition) {
                    navigation.classList.remove("collapsed");
                }
                lastScrollPosition = window.scrollY;
            }
        }
    }
}

export default SiteNavigation;
